// extracted by mini-css-extract-plugin
module.exports = {"body":"PostContent_body__4_oRU"};